module.exports = __webpack_public_path__ + "static/media/gb-wls.8742b3d6.svg";